import type { ITwoFactorLocale } from '@/Pages/Onboard/TwoFactor/Locale/TwoFactor.locale';

const esES: ITwoFactorLocale = {
  title: 'Autenticación de dos factores',
  subtitle: {
    configuring: 'Configurando tu 2FA…',
    error: 'No se pudo iniciar la configuración.',
    scan: 'Escanea el código QR de abajo con tu app autenticadora (Google Authenticator, Authy, etc.). Apunta la cámara de tu app a este código:',
  },
  generatingQRCode: 'Generando código QR…',
  qrAlt: 'Código QR 2FA',
  cannotScan: '¿No puedes escanear?',
  useCodeBelow: 'Usa el código de abajo:',
  secret: {
    label: 'Código de configuración',
    placeholder: '-',
    copyHint: 'Copia y pega este código directamente en tu app autenticadora',
    copied: '¡Copiado!',
  },
  verification: {
    label: 'Código de verificación',
    placeholder: '_ _ _ _ _ _',
    hint: 'Ingresa el código de 6 dígitos generado en tu app. Se actualiza cada 30 segundos.',
  },
  button: {
    verify: 'Verificar',
    verifyAndEnter: 'Verificar e iniciar sesión',
  },
  success: {
    title: '¡2FA activado con éxito!',
    subtitle: 'Tu cuenta ahora requiere un código de la app autenticadora al iniciar sesión.',
  },
  errors: {
    initSessionExpired: 'Sesión de configuración expirada. Inicia sesión de nuevo.',
    finishSessionExpired: 'Sesión expirada. Inicia sesión de nuevo.',
    tooManyAttempts: 'Demasiados intentos. Inténtalo de nuevo en unos segundos.',
    configRequired: 'Configuración necesaria. Recarga el inicio de sesión.',
    initGeneric: 'Error al inicializar 2FA',
    invalidCode: 'Código inválido. Verifica e inténtalo de nuevo.',
    initFirst: 'Inicia la configuración de nuevo.',
    finishGeneric: 'Error al finalizar 2FA',
    sessionMissing: 'Sesión de configuración ausente. Inicia sesión de nuevo.',
  },
};
export { esES };
